<template>
    <form
        @submit.prevent="handleSubmit"
        class="form-container"
        :class="{ 'basic-search-form covervault': display == 'default', 'search-form cia mb-4': display == 'cia' }"
        data-cy="basic-search-container"
    >
        <div class="flex w-full">
            <div
                class="flex flex-col"
                :class="{ 'w-3/4 md:w-4/5 pr-2': display == 'default', 'w-full': display == 'cia' }"
                data-cy="field-basic-search"
            >
                <ui-input
                    v-model="search_form.basic_search"
                    :class="{ 'p-6 border-default-blue-green': display == 'default' }"
                    :placeholder="
                        display == 'default'
                            ? $t('covers.search_form.placeholders.basic_search')
                            : $t('cia.search_form.placeholders.search')
                    "
                />
            </div>
            <div class="flex flex-col w-1/4 md:w-1/5 pl-2" v-if="display == 'default'">
                <ui-submit-button
                    class="2xl:w-2/3 text-xl h-full"
                    :class="{
                        ' 2xl:w-2/3 text-xl h-full ': display == 'default',
                        'text-xl text-gray-500 border-none flex flex-row items-center': display == 'cia',
                    }"
                    data-cy="button-find"
                    :disabled="processing"
                >
                    <span v-if="!processing">{{ $t('covers.search_form.buttons.find') }}</span>
                    <span v-else>{{ $t('covers.search_form.buttons.finding') }}</span>
                </ui-submit-button>
            </div>
            <div class="ml-4 cia-search" v-if="display == 'cia'">
                <a-button
                    class="text-xl border-none flex flex-row items-center h-full py-0 px-4"
                    html-type="submit"
                    data-cy="button-find"
                >
                    <SearchOutlined class="mr-1" />

                    <span>{{ $t('cia.search_form.buttons.find') }}</span>
                </a-button>
            </div>
        </div>
    </form>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';
import UiSubmitButton from '@/components/ui/SubmitButton.vue';
import { SearchOutlined } from '@ant-design/icons-vue';

export default {
    components: {
        UiInput,
        UiSubmitButton,
        SearchOutlined,
    },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
        search_form: {
            type: Object,
            default: {},
        },
        display: {
            type: String,
            default: 'default',
        },
    },
    methods: {
        handleSubmit() {
            this.$emit('formSubmit');
        },
    },
};
</script>
